<mat-card class="infoCard">
  <div class="d-flex align-items-center">
    <mat-icon class="p-2">info</mat-icon>
    <h3>{{ title() }}</h3>
  </div>
  <ng-content></ng-content>
</mat-card>
